import CharacterComparison from './CharacterComparison';
export default CharacterComparison;
